// import React, { useRef, useState, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import SelectSearchParty from "../AdminSearchExpense/SelectSearchParty";
// import { useNavigate } from "react-router-dom";
// import SelectStudentFeeModal from "../FeeStudentModal/SelectStudentFeeModal";
// import Select from "react-select";
// import { ApiUrl } from "../../../ApiUrl";
// import { Modal, Button } from "react-bootstrap";
// import ReactPaginate from "react-paginate";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";


// const AdmAttendanceEntry = () => {
//   const [showModal, setShowModal] = useState(false);
//   const navigate = useNavigate();
//   const [studentId, setStudentId] = useState("");
//   const [studentName, setStudentName] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [grievanceTypeId, setGrievanceTypeId] = useState(null);
//   const [grievancePriorityId, setGrievancePriorityId] = useState(null);
//   const [grievanceSeverityId, setGrievanceSeverityId] = useState(null);
//   const [grievanceStatus, setGrievanceStatus] = useState(""); // Avoid using "status"
//   const [loading, setLoading] = useState("");

//   const [selectedStudent, setSelectedStudent] = useState({
//     name: "",
//     barcode: "",
//     admissionNo: "",
//     fatherName: "",
//     motherName: "",
//     schoolAdmissionNo: "",
//   });
//   const [sectionId, setSectionId] = useState(null);
//   const [classId, setClassId] = useState(null);
//   //  const [classOptions, setClassOptions] = useState([]);
//   const [sectionOptions, setSectionOptions] = useState([]);
//   const [classOptions, setClassOptions] = useState([]);
//   const [transportData, setTransportData] = useState([]);
//   const [showStudentSearchModal, setShowStudentSearchModal] = useState(false);
//   const [selectedStudentId, setSelectedStudentId] = useState(null);
//   const [priorityOptions, setPriorityOptions] = useState([]);
//   const [severityOptions, setSeverityOptions] = useState([]);
//   const [options, setOptions] = useState([]);
//   const [grievances, setGrievances] = useState([]);
//   const [selectedGrievanceType, setSelectedGrievanceType] = useState(null);
//   const [selectedGrievancePriority, setSelectedGrievancePriority] =
//     useState(null);
//   const [selectedGrievanceSeverity, setSelectedGrievanceSeverity] =
//     useState(null);
//   const [selectedStatus, setSelectedStatus] = useState(null);
// const [selectedGrievance, setSelectedGrievance] = useState(null);
// const [remark, setRemark] = useState("");
//   const [studentTransportDetails, setStudentTransportDetails] = useState(null);
//   const [showUpdateModal, setShowUpdateModal] = useState(false);
//   const [currentPage, setCurrentPage] = useState(0);
//   const itemsPerPage = 10;

//   const [show, setShow] = useState(false);
//   const handleShow = () => setShow(true);
//   const handleClose = () => setShow(false);

//   const fromClassRef = useRef(null);
//   const admissionNoRef = useRef(null);
//   const barcodeRef = useRef(null);
//   const smsToRef = useRef(null);

// const handleClear = () => {
//   setStudentName(""); // Clear Student Name field
//   setClassId(null); // Clear Class dropdown
//   setSectionId(null); // Clear Section dropdown
//   setSelectedGrievanceType(null); // Clear Grievance Type dropdown
//   setSelectedGrievancePriority(null); // Clear Grievance Priority dropdown
//   setSelectedGrievanceSeverity(null); // Clear Grievance Severity dropdown
//   setSelectedStatus(null); // Clear Status dropdown
//   setFromDate(""); // Clear From Date
//   setToDate(""); // Clear To Date
//   setRemark(""); // Clear Remark field
//   setGrievances([]); // Clear table data
// };


//   // Slice data for pagination
//   const offset = currentPage * itemsPerPage;
//   const currentData = transportData.slice(offset, offset + itemsPerPage);
//   const pageCount = Math.ceil(transportData.length / itemsPerPage);

//   // Handle page change
//   const handlePageClick = ({ selected }) => {
//     setCurrentPage(selected);
//   };

//   const handleSelectStudent = (selectedStudent) => {
//     const fullName = [
//       selectedStudent.studentBasicDetails.first_name || "",
//       selectedStudent.studentBasicDetails.middle_name || "",
//       selectedStudent.studentBasicDetails.last_name || "",
//     ]
//       .filter(Boolean)
//       .join(" ");

//     // Set studentId when selecting a student (we will use this for the search)
//     setStudentId(selectedStudent.studentBasicDetails.id || "");
//     setStudentName(fullName); // Set student name for display (not used for search)
//     setClassId(selectedStudent.studentBasicDetails.addmitted_class || null);
//     setSectionId(selectedStudent.studentBasicDetails.addmitted_section || null);

//     handleCloseModal();
//   };

//    const handleCloseModal = () => {
//      setShowModal(false);
//      setSelectedStudent(null);
//      setStudentTransportDetails(null);
//    };

//   useEffect(() => {
//     const fetchSectionData = async () => {
//       if (!classId) {
//         setSectionOptions([]); // Clear sections if no class selected
//         return;
//       }

//       console.log("Fetching sections for classId:", classId); // Debugging

//       try {
//         const response = await fetch(
//           `${ApiUrl.apiurl}ClassSectionBind/GetAllSectionBindWithClass/${classId}`
//         );
//         const data = await response.json();

//         console.log("Section API response:", data); // Debugging

//         if (data.message === "success") {
//           const formattedSections = data.data.map((sectionItem) => ({
//             value: sectionItem.id,
//             label: sectionItem.sectionname,
//           }));
//           setSectionOptions(formattedSections);
//         } else {
//           console.error("Failed to fetch sections: ", data.message);
//           setSectionOptions([]);
//         }
//       } catch (error) {
//         console.error("Error fetching section data:", error);
//         setSectionOptions([]);
//       }
//     };

//     fetchSectionData();
//   }, [classId]);

//   useEffect(() => {
//     const fetchClassData = async () => {
//       try {
//         const response = await fetch(`${ApiUrl.apiurl}Class/GetAllClass`);
//         const data = await response.json();

//         if (data.message === "Success") {
//           const formattedClasses = data.data.map((classItem) => ({
//             value: classItem.id,
//             label: classItem.classname,
//           }));
//           setClassOptions(formattedClasses);
//         } else {
//           console.error("Failed to fetch classes: ", data.message);
//         }
//       } catch (error) {
//         console.error("Error fetching class data:", error);
//       }
//     };

//     fetchClassData();
//   }, []);

//   // const handleOpenModal = () => {
//   //   setShowModal(true);
//   // };

//   // const handleCloseModal = () => {
//   //   setShowModal(false);
//   // };
//   useEffect(() => {
//     fetch(`${ApiUrl.apiurl}GrievanceType/list/`)
//       .then((response) => response.json())
//       .then((data) => {
//         if (data && data.data) {
//           const formattedOptions = data.data.map((item) => ({
//             value: item.Giv_id,
//             label: item.GrievanceType,
//           }));
//           setOptions(formattedOptions);
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching grievance types:", error);
//       });
//   }, []);
//   useEffect(() => {
//     fetch(`${ApiUrl.apiurl}GrievancePriority/list/`)
//       .then((response) => response.json())
//       .then((data) => {
//         if (data && data.data) {
//           const formattedOptions = data.data.map((item) => ({
//             value: item.GP_id,
//             label: item.PriorityType,
//           }));
//           setPriorityOptions(formattedOptions);
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching grievance priorities:", error);
//       });
//   }, []);

//   useEffect(() => {
//     fetch(`${ApiUrl.apiurl}GrievanceSeverity/list/`)
//       .then((response) => response.json())
//       .then((data) => {
//         if (data && data.data) {
//           const formattedOptions = data.data.map((item) => ({
//             value: item.Sev_id,
//             label: item.SeverityType,
//           }));
//           setSeverityOptions(formattedOptions);
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching grievance severity:", error);
//       });
//   }, []);

//   const handleSearch = async () => {
//   try {
//     setLoading(true); // Set loading state

//     const orgId = localStorage.getItem("orgId");
//     const branchId = localStorage.getItem("branchId");

//     if (!orgId || !branchId) {
//       console.error("Missing orgId or branchId in local storage");
//       setLoading(false);
//       return;
//     }

//     const queryParams = new URLSearchParams({
//       org_id: orgId,
//       branch_id: branchId,
//     });

//     if (studentId) queryParams.append("studentId", studentId);
//     if (classId) queryParams.append("classId", classId);
//     if (sectionId) queryParams.append("sectionId", sectionId);
//     if (selectedGrievanceType) queryParams.append("grievancetypeId", selectedGrievanceType.value);
//     if (selectedGrievancePriority) queryParams.append("grievancepriorityId", selectedGrievancePriority.value);
//     if (selectedGrievanceSeverity) queryParams.append("grievancesecurityId", selectedGrievanceSeverity.value);
//     if (fromDate) queryParams.append("from_date", fromDate);
//     if (toDate) queryParams.append("to_date", toDate);
//     if (selectedStatus) queryParams.append("status", selectedStatus.value);

//     const apiUrl = `${ApiUrl.apiurl}Grievance/list/?${queryParams.toString()}`;

//     const controller = new AbortController(); // Create an AbortController to cancel slow requests
//     const timeoutId = setTimeout(() => controller.abort(), 5000); // Set timeout for 5 seconds

//     const response = await fetch(apiUrl, { signal: controller.signal });

//     clearTimeout(timeoutId); // Clear timeout when response is received

//     if (!response.ok) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }

//     const data = await response.json();
//     setGrievances(data?.data || []); // Update state with fetched data

//   } catch (error) {
//     if (error.name === "AbortError") {
//       console.error("Request timed out");
//     } else {
//       console.error("Error fetching grievances:", error);
//     }
//   } finally {
//     setLoading(false); // Reset loading state
//   }
// };


//  const handleSave = async () => {
//    if (!selectedGrievance) {
//      alert("No grievance selected!");
//      return;
//    }

//    const userId = sessionStorage.getItem("userId");
//    if (!userId) {
//      alert("User not found. Please log in again.");
//      return;
//    }

//    const updatedData = {
//      Grievance_id: selectedGrievance.Grievance_id,
//      ActionTaken: remark.trim(),
//      updated_by: userId,
//    };

//    try {
//      const response = await fetch(
//        `${ApiUrl.apiurl}Grievance/update/`,
//        {
//          method: "PUT",
//          headers: {
//            "Content-Type": "application/json",
//          },
//          body: JSON.stringify(updatedData),
//        }
//      );

//      if (response.ok) {
//        alert("Grievance updated successfully!");
//        // Refresh the list
//        handleCloseUpdateModal();
//      } else {
//        alert("Failed to update grievance.");
//      }
//    } catch (error) {
//      console.error("Error updating grievance:", error);
//      alert("An error occurred while updating.");
//    }
//  };

//  const handleShowUpdateModal = (event, grievance) => {
//    event.preventDefault(); // Prevent default anchor behavior
//    setSelectedGrievance(grievance);
//    setRemark(grievance.remark || "");
//    setShowUpdateModal(true);
//  };
//   const handleCloseUpdateModal = () => {
//     setShowUpdateModal(false);
//     setSelectedGrievance(null);
//     setRemark("");
//   };
//   // Function to open modal with selected grievance data


//   return (
//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-12">
//           <div className="card p-0">
//             <div className="card-body">
//               <p
//                 style={{
//                   marginBottom: "0px",
//                   textAlign: "center",
//                   fontSize: "20px",
//                   fontWeight: "700",
//                 }}
//               >
//                 STUDENT GRIEVANCES
//               </p>
//               <div className="row mb-3 mt-3 mx-0">
//                 <div className="col-12 d-flex flex-wrap gap-2">
//                   <button
//                     type="button"
//                     className="btn btn-primary me-2"
//                     style={{
//                       width: "150px",
//                     }}
//                     onClick={handleSearch}
//                   >
//                     Search
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-secondary me-2"
//                     onClick={handleClear}
//                     style={{
//                       width: "150px",
//                     }}
//                   >
//                     Clear
//                   </button>

//                   <button
//                     type="button"
//                     className="btn btn-danger me-2"
//                     style={{
//                       width: "150px",
//                     }}
//                     onClick={() => navigate("/admin/dashboard")}
//                   >
//                     Close
//                   </button>
//                 </div>
//               </div>

//               <div className="row mt-3 mx-2">
//                 <div className="col-12 custom-section-box">
//                   <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
//                     <div className="row flex-grow-1">
//                       <div className="col-12 col-md-3 mb-1">
//                         <label htmlFor="student-name" className="form-label">
//                           Student Name
//                         </label>
//                         <div className="d-flex align-items-center">
//                           <input
//                             type="text"
//                             className="form-control detail"
//                             placeholder="Enter student name"
//                             value={studentName}
//                             onChange={(e) => setStudentName(e.target.value)}
//                           />
//                           <button
//                             type="button"
//                             className="btn btn-primary ms-2 mb-0 mt-0"
//                             onClick={handleShow}
//                             style={{ width: "50px", padding: "3px" }}
//                           >
//                             ...
//                           </button>
//                         </div>
//                       </div>

//                       <SelectStudentFeeModal
//                         show={show}
//                         handleClose={handleClose}
//                         onSelectStudent={handleSelectStudent}
//                       />

//                       <div className="col-md-3">
//                         <label htmlFor="class" className="form-label">
//                           Class
//                         </label>

//                         <Select
//                           options={classOptions}
//                           className="detail"
//                           classNamePrefix="react-select"
//                           isClearable={true}
//                           placeholder="Select Class"
//                           value={
//                             classOptions.find(
//                               (option) => option.value === classId
//                             ) || null
//                           } // Match the selected class
//                           onChange={(selectedOption) =>
//                             setClassId(
//                               selectedOption ? selectedOption.value : null
//                             )
//                           }
//                         />
//                       </div>

//                       <div className="col-md-3">
//                         <label htmlFor="section" className="form-label">
//                           Section
//                         </label>
//                         <Select
//                           options={sectionOptions}
//                           className="detail"
//                           classNamePrefix="react-select"
//                           isClearable={true}
//                           placeholder="Select Section"
//                           value={
//                             sectionOptions.find(
//                               (option) => option.value === sectionId
//                             ) || null
//                           }
//                           onChange={(selectedOption) => {
//                             console.log(
//                               "Selected sectionId:",
//                               selectedOption ? selectedOption.value : null
//                             ); // Debugging
//                             setSectionId(
//                               selectedOption ? selectedOption.value : null
//                             );
//                           }}
//                         />
//                       </div>

//                       <div className="col-md-3 mb-3">
//                         <label htmlFor="grievance-type" className="form-label">
//                           GrievanceType
//                         </label>
//                         <Select
//                           classNamePrefix="react-select"
//                           isClearable={true}
//                           className="detail"
//                           placeholder="Select"
//                           options={options}
//                           value={selectedGrievanceType}
//                           onChange={(selectedOption) =>
//                             setSelectedGrievanceType(selectedOption)
//                           }
//                         />
//                       </div>

//                       <div className="col-md-3 mb-1">
//                         <label
//                           htmlFor="grievance-priority"
//                           className="form-label"
//                         >
//                           GrievancePriority
//                         </label>
//                         <Select
//                           classNamePrefix="react-select"
//                           isClearable={true}
//                           className="detail"
//                           placeholder="Select"
//                           options={priorityOptions}
//                           value={selectedGrievancePriority}
//                           onChange={(selectedOption) =>
//                             setSelectedGrievancePriority(selectedOption)
//                           }
//                         />
//                       </div>

//                       <div className="col-md-3">
//                         <label
//                           htmlFor="grievance-severity"
//                           className="form-label"
//                         >
//                           GrievanceSeverity
//                         </label>
//                         <Select
//                           classNamePrefix="react-select"
//                           isClearable={true}
//                           className="detail"
//                           placeholder="Select"
//                           options={severityOptions}
//                           value={selectedGrievanceSeverity}
//                           onChange={(selectedOption) =>
//                             setSelectedGrievanceSeverity(selectedOption)
//                           }
//                         />
//                       </div>

//                       <div className="col-md-3">
//                         <label htmlFor="status" className="form-label">
//                           Status
//                         </label>
//                         <Select
//                           classNamePrefix="react-select"
//                           isClearable={true}
//                           className="detail"
//                           placeholder="Select"
//                           options={[
//                             { value: "A", label: "All" },
//                             { value: "Y", label: "Action Taken" },
//                             { value: "N", label: "Action Not Taken" },
//                           ]}
//                           value={selectedStatus}
//                           onChange={(selectedOption) =>
//                             setSelectedStatus(selectedOption)
//                           }
//                         />
//                       </div>

//                       <div className="col-md-3 mb-3">
//                         <label style={{ fontWeight: "700" }}>From Date</label>
//                         <input
//                           type="date"
//                           className="form-control detail"
//                           value={fromDate}
//                           onChange={(e) => setFromDate(e.target.value)}
//                         />
//                       </div>

//                       <div className="col-md-3 mb-3">
//                         <label style={{ fontWeight: "700" }}>To Date</label>
//                         <input
//                           type="date"
//                           className="form-control detail"
//                           value={toDate}
//                           onChange={(e) => setToDate(e.target.value)}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="col-12">
//                 <div className="table-responsive">
//                   {loading ? (
//                     <p>Loading grievances...</p>
//                   ) : (
//                     <table className="table">
//                       <thead>
//                         <tr>
//                           <th>Sr.No</th>
//                           <th>Grievance #</th>
//                           <th>Student Name</th>
//                           <th>Class</th>
//                           <th>Section</th>
//                           <th>Barcode</th>
//                           <th>Type</th>
//                           <th>Severity</th>
//                           <th>Priority</th>
//                           <th>Grievance</th>
//                           <th>Submitted Date</th>
//                           <th> Document</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {grievances.length > 0 ? (
//                           grievances.map((grievance, index) => (
//                             <tr key={grievance.Grievance_id}>
//                               <td>{index + 1}</td>
//                               <td>{grievance.GrievanceNumber}</td>
//                               <td>{grievance.student_name || "N/A"}</td>
//                               <td>{grievance.classname || "N/A"}</td>
//                               <td>{grievance.sectionname || "N/A"}</td>
//                               <td>{grievance.barcode || "N/A"}</td>
//                               <td>{grievance.GrievanceType}</td>
//                               <td>{grievance.GrievanceSeverity}</td>
//                               <td>{grievance.GrievancePriority}</td>
//                               <td>{grievance.details}</td>
//                               <td>{grievance.submited_date}</td>
//                               <td>
//                                 {grievance.file_path ? (
//                                   <a
//                                     href={grievance.upload_file_binary}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                   >
//                                     View
//                                   </a>
//                                 ) : (
//                                   "No Document"
//                                 )}
//                               </td>
//                               <td>
//                                 <a
//                                   href="#"
//                                   key={grievance.Grievance_id}
//                                   onClick={(event) =>
//                                     handleShowUpdateModal(event, grievance)
//                                   }
//                                 >
//                                   Action
//                                 </a>
//                               </td>

//                               <Modal
//                                 show={showUpdateModal}
//                                 onHide={handleCloseUpdateModal}
//                                 centered
//                                 backdrop={true} // Enable backdrop
//                                 keyboard={false}
//                                 size="lg"
//                                 backdropClassName="custom-backdrop" // Apply custom blur effect
//                               >
//                                 <Modal.Header closeButton>
//                                   <Modal.Title>Update Grievance</Modal.Title>
//                                 </Modal.Header>

//                                 <Modal.Body>
//                                   <div className="mb-3">
//                                     <label className="fw-bold">Remark:</label>
//                                     <input
//                                       type="text"
//                                       className="form-control detail"
//                                       placeholder="Enter remark"
//                                       value={remark}
//                                       onChange={(e) =>
//                                         setRemark(e.target.value)
//                                       }
//                                     />
//                                   </div>

//                                   <div className="d-flex justify-content-center">
//                                     <button
//                                       type="button"
//                                       className="btn btn-primary me-2"
//                                       style={{ width: "150px" }}
//                                       onClick={handleSave}
//                                     >
//                                       Save
//                                     </button>
//                                     <button
//                                       type="button"
//                                       className="btn btn-secondary me-2"
//                                       style={{ width: "150px" }}
//                                       onClick={handleClear}
//                                     >
//                                       Clear
//                                     </button>
//                                     <button
//                                       type="button"
//                                       className="btn btn-danger"
//                                       style={{ width: "150px" }}
//                                       onClick={handleCloseUpdateModal}
//                                     >
//                                       Close
//                                     </button>
//                                   </div>
//                                 </Modal.Body>

//                                 {/* Inline CSS for Background Blur */}
//                                 <style>
//                                   {`
//       .custom-backdrop {
//         backdrop-filter: blur(2px); /* Apply blur effect */
//         background-color: rgba(149, 149, 149, 0.3) !important; /* Semi-transparent */
//       }
//     `}
//                                 </style>
//                               </Modal>
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td colSpan="13" className="text-center">
//                               No Data Available
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdmAttendanceEntry;



import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import SelectSearchParty from "../AdminSearchExpense/SelectSearchParty";
import { useNavigate } from "react-router-dom";
import SelectStudentFeeModal from "../FeeStudentModal/SelectStudentFeeModal";
import Select from "react-select";
import { ApiUrl } from "../../../ApiUrl";
import { Modal, Button } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const AdmAttendanceEntry = () => {
  const todayDate = new Date().toISOString().split("T")[0];
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [studentId, setStudentId] = useState("");
  const [studentName, setStudentName] = useState("");
  const [fromDate, setFromDate] = useState(todayDate);
  const [toDate, setToDate] = useState(todayDate);
  const [grievanceTypeId, setGrievanceTypeId] = useState(null);
  const [grievancePriorityId, setGrievancePriorityId] = useState(null);
  const [grievanceSeverityId, setGrievanceSeverityId] = useState(null);
  const [grievanceStatus, setGrievanceStatus] = useState(""); // Avoid using "status"
  const [loading, setLoading] = useState("");

  const [selectedStudent, setSelectedStudent] = useState({
    name: "",
    barcode: "",
    admissionNo: "",
    fatherName: "",
    motherName: "",
    schoolAdmissionNo: "",
  });
  const [sectionId, setSectionId] = useState(null);
  const [classId, setClassId] = useState(null);
  //  const [classOptions, setClassOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [transportData, setTransportData] = useState([]);
  const [showStudentSearchModal, setShowStudentSearchModal] = useState(false);
  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const [priorityOptions, setPriorityOptions] = useState([]);
  const [severityOptions, setSeverityOptions] = useState([]);
  const [options, setOptions] = useState([]);
  const [grievances, setGrievances] = useState([]);
  const [selectedGrievanceType, setSelectedGrievanceType] = useState(null);
  const [selectedGrievancePriority, setSelectedGrievancePriority] =
    useState(null);
  const [selectedGrievanceSeverity, setSelectedGrievanceSeverity] =
    useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedGrievance, setSelectedGrievance] = useState(null);
  const [actionTaken, setActionTaken] = useState("Pending");
  const [studentTransportDetails, setStudentTransportDetails] = useState(null);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const fromClassRef = useRef(null);
  const admissionNoRef = useRef(null);
  const barcodeRef = useRef(null);
  const smsToRef = useRef(null);

 const handleClear = () => {
   setStudentId(""); //  Clear Student ID
   setStudentName(""); // Clear Student Name field
   setClassId(null); // Clear Class dropdown
   setSectionId(null); // Clear Section dropdown
   setSelectedGrievanceType(null); // Clear Grievance Type dropdown
   setSelectedGrievancePriority(null); // Clear Grievance Priority dropdown
   setSelectedGrievanceSeverity(null); // Clear Grievance Severity dropdown
   setSelectedStatus(null); // Clear Status dropdown
   setFromDate(todayDate);
   setToDate(todayDate);
  //  setRemark(""); //  Clear Remark too if needed
   setGrievances([]); // Clear table data
 };



   const handleClearModal = () => {
     setActionTaken("Pending");
   }
  // Slice data for pagination
  const offset = currentPage * itemsPerPage;
  const currentData = transportData.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(transportData.length / itemsPerPage);

  // Handle page change
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  // const handleSelectStudent = (selectedStudent) => {
  //   const fullName = [
  //     selectedStudent.studentBasicDetails.first_name || "",
  //     selectedStudent.studentBasicDetails.middle_name || "",
  //     selectedStudent.studentBasicDetails.last_name || "",
  //   ]
  //     .filter(Boolean)
  //     .join(" ");

  //   // Set studentId when selecting a student (we will use this for the search)
  //   setStudentId(selectedStudent.studentBasicDetails.id || "");
  //   setStudentName(fullName); // Set student name for display (not used for search)
  //   setClassId(selectedStudent.studentBasicDetails.addmitted_class || null);
  //   setSectionId(selectedStudent.studentBasicDetails.addmitted_section || null);

  //   handleCloseModal();
  // };
const handleSelectStudent = (selectedStudent) => {
  // Build full name from the top-level studentname field
  const fullName = selectedStudent.studentname || "";

  // Set studentId when selecting a student
  setStudentId(selectedStudent.studentId || ""); // Use studentId from API
  setStudentName(fullName); // Set student name for display
  setClassId(selectedStudent.classId || null); // Top-level classId
  setSectionId(selectedStudent.sectionId || null); // Top-level sectionId

  handleCloseModal();
};

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedStudent(null);
    setStudentTransportDetails(null);
  };

  useEffect(() => {
    const fetchSectionData = async () => {
      if (!classId) {
        setSectionOptions([]); // Clear sections if no class selected
        return;
      }

      console.log("Fetching sections for classId:", classId); // Debugging

      try {
        const response = await fetch(
          `${ApiUrl.apiurl}ClassSectionBind/GetAllSectionBindWithClass/${classId}`
        );
        const data = await response.json();

        console.log("Section API response:", data); // Debugging

        if (data.message === "success") {
          const formattedSections = data.data.map((sectionItem) => ({
            value: sectionItem.section_id,
            label: sectionItem.sectionname,
          }));
          setSectionOptions(formattedSections);
        } else {
          console.error("Failed to fetch sections: ", data.message);
          setSectionOptions([]);
        }
      } catch (error) {
        console.error("Error fetching section data:", error);
        setSectionOptions([]);
      }
    };

    fetchSectionData();
  }, [classId]);

  useEffect(() => {
    const fetchClassData = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}Class/GetAllClass`);
        const data = await response.json();

        if (data.message === "Success") {
          const formattedClasses = data.data.map((classItem) => ({
            value: classItem.id,
            label: classItem.classname,
          }));
          setClassOptions(formattedClasses);
        } else {
          console.error("Failed to fetch classes: ", data.message);
        }
      } catch (error) {
        console.error("Error fetching class data:", error);
      }
    };

    fetchClassData();
  }, []);

  // const handleOpenModal = () => {
  //   setShowModal(true);
  // };

  // const handleCloseModal = () => {
  //   setShowModal(false);
  // };
  useEffect(() => {
    fetch(`${ApiUrl.apiurl}GrievanceType/list/`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.data) {
          const formattedOptions = data.data.map((item) => ({
            value: item.Giv_id,
            label: item.GrievanceType,
          }));
          setOptions(formattedOptions);
        }
      })
      .catch((error) => {
        console.error("Error fetching grievance types:", error);
      });
  }, []);
  useEffect(() => {
    fetch(`${ApiUrl.apiurl}GrievancePriority/list/`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.data) {
          const formattedOptions = data.data.map((item) => ({
            value: item.GP_id,
            label: item.PriorityType,
          }));
          setPriorityOptions(formattedOptions);
        }
      })
      .catch((error) => {
        console.error("Error fetching grievance priorities:", error);
      });
  }, []);

  useEffect(() => {
    fetch(`${ApiUrl.apiurl}GrievanceSeverity/list/`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.data) {
          const formattedOptions = data.data.map((item) => ({
            value: item.Sev_id,
            label: item.SeverityType,
          }));
          setSeverityOptions(formattedOptions);
        }
      })
      .catch((error) => {
        console.error("Error fetching grievance severity:", error);
      });
  }, []);

  const handleSearch = async () => {
    try {
      setLoading(true); // Set loading state

      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");

      if (!orgId || !branchId) {
        console.error("Missing orgId or branchId in local storage");
        setLoading(false);
        return;
      }

      const queryParams = new URLSearchParams({
        org_id: orgId,
        branch_id: branchId,
      });

      if (studentId) queryParams.append("studentId", studentId);
      if (classId) queryParams.append("classId", classId);
      if (sectionId) queryParams.append("sectionId", sectionId);
      if (selectedGrievanceType)
        queryParams.append("grievancetypeId", selectedGrievanceType.value);
      if (selectedGrievancePriority)
        queryParams.append(
          "grievancepriorityId",
          selectedGrievancePriority.value
        );
      if (selectedGrievanceSeverity)
        queryParams.append(
          "grievancesecurityId",
          selectedGrievanceSeverity.value
        );
      if (fromDate) queryParams.append("from_date", fromDate);
      if (toDate) queryParams.append("to_date", toDate);
      if (selectedStatus) queryParams.append("status", selectedStatus.value);

      const apiUrl = `${
        ApiUrl.apiurl
      }Grievance/list/?${queryParams.toString()}`;

      const controller = new AbortController(); // Create an AbortController to cancel slow requests
      const timeoutId = setTimeout(() => controller.abort(), 5000); // Set timeout for 5 seconds

      const response = await fetch(apiUrl, { signal: controller.signal });

      clearTimeout(timeoutId); // Clear timeout when response is received

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setGrievances(data?.data || []); // Update state with fetched data
    } catch (error) {
      if (error.name === "AbortError") {
        console.error("Request timed out");
      } else {
        console.error("Error fetching grievances:", error);
      }
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  useEffect(() => {
    handleSearch();
  }, []);

  const handleSave = async () => {
    if (!selectedGrievance) {
      alert("No grievance selected!");
      return;
    }

    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      alert("User not found. Please log in again.");
      return;
    }

    const updatedData = {
      Grievance_id: selectedGrievance.Grievance_id,
      ActionTaken: actionTaken,
      updated_by: userId,
    };

    try {
      const response = await fetch(`${ApiUrl.apiurl}Grievance/update/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedData),
      });

      if (response.ok) {
        alert("Grievance updated successfully!");
        await handleSearch();
        handleCloseUpdateModal();
      } else {
        alert("Failed to update grievance.");
      }
    } catch (error) {
      console.error("Error updating grievance:", error);
      alert("An error occurred while updating.");
    }
  };

  const handleShowUpdateModal = (event, grievance) => {
    event.preventDefault(); // Prevent default anchor behavior
    setSelectedGrievance(grievance);
    setActionTaken(grievance.ActionTaken || "Pending");
    setShowUpdateModal(true);
  };
  const handleCloseUpdateModal = () => {
    setShowUpdateModal(false);
    setSelectedGrievance(null);
    setActionTaken("Pending");
  };

  const handleSaveStatus = async (grievanceId, status) => {
    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      alert("User not found. Please log in again.");
      return;
    }

    const updatedData = {
      Grievance_id: grievanceId,
      ActionTaken: status,
      updated_by: userId,
    };

    try {
      const response = await fetch(`${ApiUrl.apiurl}Grievance/update/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedData),
      });

      if (response.ok) {
        console.log("Grievance status updated successfully!");
        await handleSearch();
      } else {
        alert("Failed to update grievance status.");
      }
    } catch (error) {
      console.error("Error updating grievance status:", error);
      alert("An error occurred while updating.");
    }
  };

  // Function to open modal with selected grievance data

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT GRIEVANCES
              </p>
              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={handleClear}
                    style={{
                      width: "150px",
                    }}
                  >
                    Clear
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn me-2"
                    style={{
                      width: "150px",
                      backgroundColor: "#0D6EFD",
                      borderColor: "#0D6EFD",
                      color: "#fff",
                    }}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1">
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="student-name" className="form-label">
                          Student Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            className="form-control detail"
                            placeholder="Enter student name"
                            value={studentName}
                            onChange={(e) => setStudentName(e.target.value)}
                          />
                          <button
                            type="button"
                            className="btn btn-primary ms-2 mb-0 mt-0"
                            onClick={handleShow}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                        </div>
                      </div>

                      <SelectStudentFeeModal
                        show={show}
                        handleClose={handleClose}
                        onSelectStudent={handleSelectStudent}
                      />

                      <div className="col-md-3">
                        <label htmlFor="class" className="form-label">
                          Class
                        </label>

                        <Select
                          options={classOptions}
                          className="detail"
                          classNamePrefix="react-select"
                          placeholder="Select Class"
                          value={
                            classOptions.find(
                              (option) => option.value === classId
                            ) || null
                          } // Match the selected class
                          onChange={(selectedOption) =>
                            setClassId(
                              selectedOption ? selectedOption.value : null
                            )
                          }
                        />
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="section" className="form-label">
                          Section
                        </label>
                        <Select
                          options={sectionOptions}
                          className="detail"
                          classNamePrefix="react-select"
                          placeholder="Select Section"
                          value={
                            sectionOptions.find(
                              (option) => option.value === sectionId
                            ) || null
                          }
                          onChange={(selectedOption) => {
                            console.log(
                              "Selected sectionId:",
                              selectedOption ? selectedOption.value : null
                            ); // Debugging
                            setSectionId(
                              selectedOption ? selectedOption.value : null
                            );
                          }}
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label htmlFor="grievance-type" className="form-label">
                          GrievanceType
                        </label>
                        <Select
                          classNamePrefix="react-select"
                          className="detail"
                          placeholder="Select"
                          options={options}
                          value={selectedGrievanceType}
                          onChange={(selectedOption) =>
                            setSelectedGrievanceType(selectedOption)
                          }
                        />
                      </div>

                      <div className="col-md-3 mb-1">
                        <label
                          htmlFor="grievance-priority"
                          className="form-label"
                        >
                          GrievancePriority
                        </label>
                        <Select
                          classNamePrefix="react-select"
                          className="detail"
                          placeholder="Select"
                          options={priorityOptions}
                          value={selectedGrievancePriority}
                          onChange={(selectedOption) =>
                            setSelectedGrievancePriority(selectedOption)
                          }
                        />
                      </div>

                      <div className="col-md-3">
                        <label
                          htmlFor="grievance-severity"
                          className="form-label"
                        >
                          GrievanceSeverity
                        </label>
                        <Select
                          classNamePrefix="react-select"
                          className="detail"
                          placeholder="Select"
                          options={severityOptions}
                          value={selectedGrievanceSeverity}
                          onChange={(selectedOption) =>
                            setSelectedGrievanceSeverity(selectedOption)
                          }
                        />
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="status" className="form-label">
                          Status
                        </label>
                        <Select
                          classNamePrefix="react-select"
                          className="detail"
                          placeholder="Select"
                          options={[
                            { value: "A", label: "All" },
                            { value: "Y", label: "Action Taken" },
                            { value: "N", label: "Action Not Taken" },
                          ]}
                          value={selectedStatus}
                          onChange={(selectedOption) =>
                            setSelectedStatus(selectedOption)
                          }
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label style={{ fontWeight: "700" }}>From Date</label>
                        <input
                          type="date"
                          className="form-control detail"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label style={{ fontWeight: "700" }}>To Date</label>
                        <input
                          type="date"
                          className="form-control detail"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Grievance</th>
                        <th>Student Name</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Barcode</th>
                        <th>Type</th>
                        <th>Severity</th>
                        <th>Priority</th>
                        <th>Details</th>
                        <th>Submitted Date</th>
                        <th>Document</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {grievances.length > 0 ? (
                        grievances.map((grievance, index) => (
                          <tr key={grievance.Grievance_id}>
                            <td>{index + 1}</td>
                            <td>{grievance.GrievanceNumber}</td>
                            <td>{grievance.student_name || "N/A"}</td>
                            <td>{grievance.classname || "N/A"}</td>
                            <td>{grievance.sectionname || "N/A"}</td>
                            <td>{grievance.barcode || "N/A"}</td>
                            <td>{grievance.GrievanceType}</td>
                            <td>{grievance.GrievanceSeverity}</td>
                            <td>{grievance.GrievancePriority}</td>
                            <td>{grievance.details}</td>
                            <td>{grievance.submited_date}</td>
                            <td>
                              {grievance.file_path ? (
                                <a
                                  href={grievance.file_path}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View
                                </a>
                              ) : (
                                "No Document"
                              )}
                            </td>
                            <td>
                              <select
                                className="form-select form-select-sm"
                                value={grievance.ActionTaken || "Pending"}
                                onChange={(event) => {
                                  const newStatus = event.target.value;
                                  setSelectedGrievance(grievance);
                                  setActionTaken(newStatus);
                                  // Auto-save the status change
                                  handleSaveStatus(grievance.Grievance_id, newStatus);
                                }}
                                style={{
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                  padding: "6px 10px",
                                  cursor: "pointer",
                                  minWidth: "120px",
                                }}
                              >
                                <option value="Pending">Pending</option>
                                <option value="Resolved">Resolved</option>
                              </select>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="13" className="text-center">
                            No Data Available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* ✅ React Paginate */}
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  activeClassName={"active"}
                />

               
                   <Modal
                                show={showUpdateModal}
                                onHide={handleCloseUpdateModal}
                                centered
                                backdrop={true} // Enable backdrop
                                keyboard={false}
                                size="lg"
                                backdropClassName="custom-backdrop" // Apply custom blur effect
                              >
                                <Modal.Header closeButton>
                                  <Modal.Title>Update Grievance</Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                  <div className="mb-3">
                                    <label htmlFor="grievance-action" className="fw-bold">
                                      Action:
                                    </label>
                                    <select
                                      id="grievance-action"
                                      className="form-control detail"
                                      value={actionTaken}
                                      onChange={(e) => setActionTaken(e.target.value)}
                                    >
                                      <option value="Pending">Pending</option>
                                      <option value="Resolved">Resolved</option>
                                    </select>
                                  </div>

                                  <div className="d-flex justify-content-center">
                                    <button
                                      type="button"
                                      className="btn btn-primary me-2"
                                      style={{ width: "150px" }}
                                      onClick={handleSave}
                                    >
                                      Save
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-secondary me-2"
                                      style={{ width: "150px" }}
                                      onClick={handleClearModal}
                                    >
                                      Clear
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-danger"
                                      style={{ width: "150px" }}
                                      onClick={handleCloseUpdateModal}
                                    >
                                      Close
                                    </button>
                                  </div>
                                </Modal.Body>

                                {/* Inline CSS for Background Blur */}
                                <style>
                                  {`
      .custom-backdrop {
        backdrop-filter: blur(2px); /* Apply blur effect */
        background-color: rgba(149, 149, 149, 0.3) !important; /* Semi-transparent */
      }
    `}
                                </style>
                              </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
